import SadFace from "../../assets/sadFace.webp";
export const FailedToLoadImage = () => {
  return (
    <div className="overflow-hidden">
      <img src={SadFace} alt="sad face" className="object-contain" />
    </div>
  );
};
